import { getI18n } from '@bridebook/web/lib/i18n/getI18n';
import { UrlHelper } from '@bridebook/web/lib/url-helper';

export interface IArticleCategory {
  value: string;
  id: string;
  label: string;
}

interface IArticleWithTerms {
  slug: string;
  terms?: { category?: Array<{ slug: string }> | null } | null;
}

export const getArticlePath = (article: IArticleWithTerms): string =>
  UrlHelper.article.id(article.slug);

export const ARTICLE_CATEGORY_SLUGS: Array<string> = [
  'before-the-big-day',
  'engagement',
  'budget-and-costs',
  'ceremony-and-vows',
  'wedding-speeches',
  'wedding-fashion',
  'wedding-flowers',
  'wedding-decor-styling',
  'wedding-food-and-drink',
  'wedding-entertainment-music',
  'wedding-stationery-wording',
  'venues',
  'stag-and-hen',
  'wedding-guests-gifting',
  'honeymoons-travel',
  'love-relationships',
  'real-weddings',
];

export const getArticleCategoriesList = (): Array<IArticleCategory> => {
  const i18n = getI18n();

  return [
    {
      value: '',
      id: 'all',
      label: i18n.t('articles:categoryName.all'),
    },
    {
      value: 'before-the-big-day',
      id: 'before-the-big-day',
      label: i18n.t('articles:categoryName.beforeTheBigDay'),
    },
    {
      value: 'engagement',
      id: 'engagement',
      label: i18n.t('articles:categoryName.engagement'),
    },
    {
      value: 'budget-and-costs',
      id: 'budget-and-costs',
      label: i18n.t('articles:categoryName.budgetCosts'),
    },
    {
      value: 'ceremony-and-vows',
      id: 'ceremony-and-vows',
      label: i18n.t('articles:categoryName.ceremonyVows'),
    },
    {
      value: 'wedding-speeches',
      id: 'wedding-speeches',
      label: i18n.t('articles:categoryName.speeches'),
    },
    {
      value: 'wedding-fashion',
      id: 'wedding-fashion',
      label: i18n.t('articles:categoryName.weddingFashion'),
    },
    {
      value: 'wedding-flowers',
      id: 'wedding-flowers',
      label: i18n.t('articles:categoryName.flowers'),
    },
    {
      value: 'wedding-decor-styling',
      id: 'wedding-decor-styling',
      label: i18n.t('articles:categoryName.decorStyling'),
    },
    {
      value: 'wedding-food-and-drink',
      id: 'wedding-food-and-drink',
      label: i18n.t('articles:categoryName.foodDrink'),
    },
    {
      value: 'wedding-entertainment-music',
      id: 'wedding-entertainment-music',
      label: i18n.t('articles:categoryName.entertainmentMusic'),
    },
    {
      value: 'wedding-stationery-wording',
      id: 'wedding-stationery-wording',
      label: i18n.t('articles:categoryName.stationeryWording'),
    },
    {
      value: 'venues',
      id: 'venues',
      label: i18n.t('articles:categoryName.venues'),
    },
    {
      value: 'stag-and-hen',
      id: 'stag-and-hen',
      label: i18n.t('articles:categoryName.preWeddingParties'),
    },
    {
      value: 'wedding-guests-gifting',
      id: 'wedding-guests-gifting',
      label: i18n.t('articles:categoryName.guestsGifting'),
    },
    {
      value: 'honeymoons-travel',
      id: 'honeymoons-travel',
      label: i18n.t('articles:categoryName.honeymoonsTravel'),
    },
    {
      value: 'love-relationships',
      id: 'love-relationships',
      label: i18n.t('articles:categoryName.loveRelationships'),
    },
    {
      value: 'real-weddings',
      id: 'real-weddings',
      label: i18n.t('articles:categoryName.realWeddings'),
    },
  ];
};
